exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".international-newsletters-heading-1MLdf {\n  margin: 40px 0 20px;\n}\n\n.spinner-container-3X8ie {\n  margin: 40px 0;\n  transform: scale(2);\n}\n\n@media (max-width: 480px) {\n  .spinner-container-3X8ie {\n    margin: 20px 0;\n    transform: scale(1);\n  }\n}", ""]);

// Exports
exports.locals = {
	"international-newsletters-heading": "international-newsletters-heading-1MLdf",
	"spinner-container": "spinner-container-3X8ie"
};